import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx } from "vue";
const _hoisted_1 = ["title"];
import { translate } from '@/i18n';
import { useSettingsStore } from '@/store/modules/settings';

import { storeToRefs } from 'pinia';
export default /*@__PURE__*/_defineComponent({
  __name: 'VabSubMenu',
  props: {
    itemOrMenu: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  setup(__props) {
    const settingsStore = useSettingsStore();
    const {
      theme
    } = storeToRefs(settingsStore);
    return (_ctx, _cache) => {
      const _component_vab_icon = _resolveComponent("vab-icon");
      const _component_el_sub_menu = _resolveComponent("el-sub-menu");
      return _openBlock(), _createBlock(_component_el_sub_menu, {
        index: __props.itemOrMenu.path,
        teleported: _unref(theme).layout != 'horizontal'
      }, {
        title: _withCtx(() => [__props.itemOrMenu.meta.icon ? (_openBlock(), _createBlock(_component_vab_icon, {
          key: 0,
          icon: __props.itemOrMenu.meta.icon,
          "is-custom-svg": __props.itemOrMenu.meta.isCustomSvg,
          title: _unref(translate)(__props.itemOrMenu.meta.title)
        }, null, 8, ["icon", "is-custom-svg", "title"])) : _createCommentVNode("", true), _createElementVNode("span", {
          title: _unref(translate)(__props.itemOrMenu.meta.title)
        }, _toDisplayString(_unref(translate)(__props.itemOrMenu.meta.title)), 9, _hoisted_1)]),
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
        _: 3
      }, 8, ["index", "teleported"]);
    };
  }
});